import React from "react";
import "./PrimaryAuthInput.css";

const PrimaryAuthInput = (props) => (
	<input {...props} className={`PrimaryAuthInput ${props.borderStyle}`} />
);

export default PrimaryAuthInput;
